import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {departmentsService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {Order} from "types/common"
import {DepartmentForm} from "types/departments"

const queryCacheKey = "all-department-forms"
const INITIAL_DATA: DepartmentForm[] = []

type Props = {
    departmentId: number
}

export const useAllDepartmentForms = (props: Props) => {
    const {departmentId} = props

    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey, departmentId],
        async () => {
            const {data} = await departmentsService.getAllDepartmentForms({
                departmentId,
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                },
                sort: {
                    orderBy: "id",
                    orderDir: Order.Asc
                }
            })
            return data
        },
        {
            refetchOnMount: false
        }
    )
    return {
        departmentForms: query.data ?? INITIAL_DATA,
        invalidateDepartmentFormsCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
